import { useEffect, useId, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

function DeletePropertiesSection({ open, resourceName, onDelete, disabled = false }) {
  const [confirmed, setConfirmed] = useState(false);
  const checkboxId = useId();

  useEffect(() => {
    if (!open) setConfirmed(false);
  }, [open]);

  return (
    <SoftBox sx={{ borderBottom: "1px solid var(--portal-surface-border)", mt: 3, pb: 2.5 }}>
      <SoftTypography variant="button" color="text" sx={{ display: "block", mb: 1.5, fontSize: "14px", lineHeight: 1.6 }}>
        Deleting forever will permanently delete this {resourceName} and it cannot be retrieved. Check the box to confirm deleting forever.
      </SoftTypography>
      <SoftBox display="flex" alignItems="center" gap={1.5} mb={2}>
        <Checkbox id={checkboxId} checked={confirmed} onChange={(event) => setConfirmed(event.target.checked)} />
        <SoftTypography component="label" htmlFor={checkboxId} variant="button" color="text" sx={{ cursor: "pointer", fontSize: "14px" }}>
          I’m sure I want to delete this {resourceName}.
        </SoftTypography>
      </SoftBox>
      <SoftButton
        color="error"
        variant="contained"
        sx={{ backgroundColor: "#E53E3E !important" }}
        disabled={!confirmed || disabled}
        onClick={onDelete}
      >
        Delete forever
      </SoftButton>
    </SoftBox>
  );
}

export default DeletePropertiesSection;
